import { useContext, useEffect, useState } from "react";
import { ToolContext } from "../../../../../../core/context/ToolContext";
import { JoyrideWrapper } from "../../JoyrideWrapper";

export const ProductShipped = ({ end }) => {
	const {personalization_state} = useContext(ToolContext)
	const {walkthrough, startHere} = personalization_state
	const [firstStepReady, setFirstStepReady] = useState(false);
	const tab = new URLSearchParams(window.location.search).get('tab')

	const endTour = ()=>{
		walkthrough.set((p) => ({ ...p, productShipped: false}))
		startHere.set((p) => ({ ...p, show: true}))
		setFirstStepReady(false)
	}

	const steps = [
		{
			target: '.productShippedFirstStep',
			title: "View Order",
			content: 'Click to view order details.',
			disableBeacon: true,
			placement: "left",
		},
		{
			target: '.productShippedSecondStep',
			title: "Update Order",
			content: 'Click to update the status of this order.',
			disableBeacon: true,
			placement: "left",
		},
		{
			target: '.productShippedThirdStep',
			title: "Pay Remaining Balance",
			content: 'Make a payment to fill the remaining balance.',
			disableBeacon: true,
			placement: "top",
			modalTriggers: 'productSalesModal'
		},
		{
			target: '.productShippedFourthStep',
			title: "Move to Picked up",
			content: 'Mark this order as already been picked up.',
			disableBeacon: true,
			placement: "top",
			modalTriggers: 'productSalesModal'
		},
	]

	useEffect(() => {
		const interval = setInterval(() => {
			const el = document.querySelector('.productShippedFirstStep');
			if (el) {
				clearInterval(interval);
				setFirstStepReady(true);
			}
		}, 100);
		return () => clearInterval(interval);
	}, [tab, walkthrough.data.productShipped]);

	return (
		firstStepReady && 
		<JoyrideWrapper 
			run={Boolean(walkthrough.data.productShipped)} 
			steps={steps} 
			setter={endTour} 
			end={end}
			p_name="productShipped" 
			featureName="sales"
		/>
	);
}
